import {
  CRITICAL_CASE_PROPERTIES_CLIENT_FAIL,
  CRITICAL_CASE_PROPERTIES_CLIENT_REQUEST,
  CRITICAL_CASE_PROPERTIES_CLIENT_SUCCESS,
  CRITICAL_CASE_PROPERTIES_DEPARTMENT_FAIL,
  CRITICAL_CASE_PROPERTIES_DEPARTMENT_REQUEST,
  CRITICAL_CASE_PROPERTIES_DEPARTMENT_SUCCESS,
  CRITICAL_CASE_PROPERTIES_DETAIL_USER_ENTITIES_FAIL,
  CRITICAL_CASE_PROPERTIES_DETAIL_USER_ENTITIES_REQUEST,
  CRITICAL_CASE_PROPERTIES_DETAIL_USER_ENTITIES_SUCCESS,
  CRITICAL_CASE_PROPERTIES_FAIL,
  CRITICAL_CASE_PROPERTIES_LOCATION_FAIL,
  CRITICAL_CASE_PROPERTIES_LOCATION_REQUEST,
  CRITICAL_CASE_PROPERTIES_LOCATION_SUCCESS,
  CRITICAL_CASE_PROPERTIES_PATCH_FAIL,
  CRITICAL_CASE_PROPERTIES_PATCH_REQUEST,
  CRITICAL_CASE_PROPERTIES_PATCH_SUCCESS,
  CRITICAL_CASE_PROPERTIES_REQUEST,
  CRITICAL_CASE_PROPERTIES_SUBMIT_USER_ENTITIES_FAIL,
  CRITICAL_CASE_PROPERTIES_SUBMIT_USER_ENTITIES_REQUEST,
  CRITICAL_CASE_PROPERTIES_SUBMIT_USER_ENTITIES_SUCCESS,
  CRITICAL_CASE_PROPERTIES_SUCCESS,
  CRITICAL_CASE_PROPERTIES_USER_ENTITIES_FAIL,
  CRITICAL_CASE_PROPERTIES_USER_ENTITIES_REQUEST,
  CRITICAL_CASE_PROPERTIES_USER_ENTITIES_SUCCESS,
  CRITICAL_CASE_PROPERTIES_USER_FAIL,
  CRITICAL_CASE_PROPERTIES_USER_REQUEST,
  CRITICAL_CASE_PROPERTIES_USER_SUCCESS,
  DETAIL_DATA_CRITICAL_CASE_FAIL,
  DETAIL_DATA_CRITICAL_CASE_REQUEST,
  DETAIL_DATA_CRITICAL_CASE_SUCCESS
} from '../../../constants/medical-record/citical-case'

const initialState = {
  loadingClientSummary: false,
  loadingPatch: false,
  loadingDetailUserEntity: false,
  loadingUserEntity: false,
  loadingSubmitUserEntity: false,
  loadingLocation: false,
  dataCriticalCaseDetail: {},
  loadingDetailDataHeader: {},
  configuration: {},
  clientSummary: [],
  locationSummary: [],
  departmentSummary: [],
  pageable: {
    page: 1,
    size: 10,
    hits: 0
  },
  userEntityDetail: {},
  userEntitiesList: [],
  error: null
}

const dataCriticalCasePropertiesReducer = (state = initialState, action) => {
  switch (action.type) {
    case DETAIL_DATA_CRITICAL_CASE_REQUEST:
      return { ...state, loadingDetailDataHeader: true }
    case DETAIL_DATA_CRITICAL_CASE_SUCCESS:
      return {
        ...state,
        loadingDetailDataHeader: false,
        dataCriticalCaseDetail: action.payload
      }
    case DETAIL_DATA_CRITICAL_CASE_FAIL:
      return {
        ...state,
        loadingDetailDataHeader: false,
        error: action.payload
      }
    case CRITICAL_CASE_PROPERTIES_REQUEST:
      return { ...state, loadingProperties: true, configuration: {} }
    case CRITICAL_CASE_PROPERTIES_SUCCESS:
      return {
        ...state,
        loadingProperties: false,
        configuration: action.payload
      }
    case CRITICAL_CASE_PROPERTIES_FAIL:
      return { ...state, loadingProperties: false, error: action.payload }
    case CRITICAL_CASE_PROPERTIES_CLIENT_REQUEST:
      return { ...state, loadingClientSummary: true, clientSummary: [] }
    case CRITICAL_CASE_PROPERTIES_CLIENT_SUCCESS:
      return {
        ...state,
        loadingClientSummary: false,
        clientSummary: action.payload
      }
    case CRITICAL_CASE_PROPERTIES_CLIENT_FAIL:
      return {
        ...state,
        loadingClientSummary: false,
        clientSummary: [],
        error: action.payload
      }
    case CRITICAL_CASE_PROPERTIES_PATCH_REQUEST:
      return { ...state, loadingPatch: true }
    case CRITICAL_CASE_PROPERTIES_PATCH_SUCCESS:
      return {
        ...state,
        loadingPatch: false
      }
    case CRITICAL_CASE_PROPERTIES_PATCH_FAIL:
      return { ...state, loadingPatch: false, error: action.payload }
    case CRITICAL_CASE_PROPERTIES_USER_ENTITIES_REQUEST:
      return {
        ...state,
        loadingUserEntity: true,
        userEntitiesList: []
      }
    case CRITICAL_CASE_PROPERTIES_USER_ENTITIES_SUCCESS:
      return {
        ...state,
        loadingUserEntity: false,
        userEntitiesList: action.payload,
        pageable: action.pageable
      }
    case CRITICAL_CASE_PROPERTIES_USER_ENTITIES_FAIL:
      return { ...state, loadingUserEntity: false, error: action.payload }
    case CRITICAL_CASE_PROPERTIES_SUBMIT_USER_ENTITIES_REQUEST:
      return {
        ...state,
        loadingSubmitUserEntity: true
      }
    case CRITICAL_CASE_PROPERTIES_SUBMIT_USER_ENTITIES_SUCCESS:
      return {
        ...state,
        loadingSubmitUserEntity: false
      }
    case CRITICAL_CASE_PROPERTIES_SUBMIT_USER_ENTITIES_FAIL:
      return { ...state, loadingSubmitUserEntity: false, error: action.payload }
    case CRITICAL_CASE_PROPERTIES_DETAIL_USER_ENTITIES_REQUEST:
      return {
        ...state,
        loadingDetailUserEntity: true,
        userEntityDetail: {}
      }
    case CRITICAL_CASE_PROPERTIES_DETAIL_USER_ENTITIES_SUCCESS:
      return {
        ...state,
        loadingDetailUserEntity: false,
        userEntityDetail: action.payload
      }
    case CRITICAL_CASE_PROPERTIES_DETAIL_USER_ENTITIES_FAIL:
      return { ...state, loadingDetailUserEntity: false, error: action.payload }
    case CRITICAL_CASE_PROPERTIES_USER_REQUEST:
      return {
        ...state,
        loadingUser: true,
        userSummary: []
      }
    case CRITICAL_CASE_PROPERTIES_USER_SUCCESS:
      return {
        ...state,
        loadingUser: false,
        userSummary: action.payload
      }
    case CRITICAL_CASE_PROPERTIES_USER_FAIL:
      return { ...state, loadingUser: false, error: action.payload }
    case CRITICAL_CASE_PROPERTIES_LOCATION_REQUEST:
      return {
        ...state,
        loadingLocation: true,
        locationSummary: []
      }
    case CRITICAL_CASE_PROPERTIES_LOCATION_SUCCESS:
      return {
        ...state,
        loadingLocation: false,
        locationSummary: action.payload
      }
    case CRITICAL_CASE_PROPERTIES_LOCATION_FAIL:
      return { ...state, loadingLocation: false, error: action.payload }
    case CRITICAL_CASE_PROPERTIES_DEPARTMENT_REQUEST:
      return {
        ...state,
        loadingDepartment: true,
        departmentSummary: []
      }
    case CRITICAL_CASE_PROPERTIES_DEPARTMENT_SUCCESS:
      return {
        ...state,
        loadingDepartment: false,
        departmentSummary: action.payload
      }
    case CRITICAL_CASE_PROPERTIES_DEPARTMENT_FAIL:
      return { ...state, loadingDepartment: false, error: action.payload }
    default:
      return state
  }
}

export default dataCriticalCasePropertiesReducer
